import {isNotNil} from 'ramda';

/**
 * True when a bubbled mouse event originated on (or inside) a column resize handle
 * (marked with the `data-resize-handle` attribute by {@link ResizeHandle}).
 *
 * Used by HeaderCell's sort click handler: the handle shows a `col-resize` cursor,
 * so a click landing there must never toggle sorting.
 */
export function isEventFromResizeHandle(event: React.MouseEvent): boolean {
  return event.target instanceof Element && isNotNil(event.target.closest('[data-resize-handle]'));
}
